import { Stack } from '@mui/system';
import { Button, Link } from '@raisin/components-lib';
import { useT } from '@transifex/react';
import messages from 'messages';
import React, { FC } from 'react';
import { ProductOfferListItem } from 'types';
import * as S from '../styles';
import * as MobileStyles from './styles';
import { FinancialInstitutions } from '../FinancialInstitutions/FinancialInstitutions';
import { getInstitutionChipLabels } from '../utils';

interface MobileItemProps {
  offer: ProductOfferListItem;
  earnings: string;
  loadingProductId: string;
  openProductTerms: (productId: string) => void;
  apyDisplay: string;
  maturityDisplay: string;
  bankLogoLink?: string;
  isSavingsOffer: boolean;
  isCallableCD: boolean;
  onInvest: (productId: string) => void;
}

export const MobileItem: FC<MobileItemProps> = ({
  offer: { id, bankLogo, bankName, productName, financialInstitutions },
  earnings,
  bankLogoLink,
  apyDisplay,
  maturityDisplay,
  loadingProductId,
  openProductTerms,
  isSavingsOffer,
  isCallableCD,
  onInvest,
}) => {
  const t = useT();
  const logoElement = <S.BankLogo src={bankLogo} alt={bankName} />;

  return (
    <MobileStyles.MobileItemContainer elevation={1} data-testid="mobile-item">
      <MobileStyles.MobileItem>
        <S.BankLogoContainer $flex="0 0 20%">
          {bankLogoLink ? <a href={bankLogoLink}>{logoElement}</a> : logoElement}
        </S.BankLogoContainer>
        <S.Text variant="subtitle1" $flex="0 0 75%">
          {bankName}
        </S.Text>
      </MobileStyles.MobileItem>
      <Stack
        direction="row"
        sx={{ marginTop: '16px', alignItems: 'baseline', marginBottom: '8px' }}
        spacing={1}
      >
        <S.BlueText variant="h1">{apyDisplay}</S.BlueText>
        <S.BlueText variant="subtitle1">{t(messages.usOfferTableHeaderApy)}*</S.BlueText>
      </Stack>
      <MobileStyles.MobileItem>
        <S.Text variant="subtitle1" $color={'black60'}>
          {t(messages.usOfferTableHeaderProduct)}
        </S.Text>
        <S.Text variant="subtitle1" $color={isCallableCD ? 'blue40' : 'black100'}>
          {productName}
        </S.Text>
      </MobileStyles.MobileItem>
      {!isSavingsOffer && (
        <MobileStyles.MobileItem>
          <S.Text variant="subtitle1" $color={'black60'}>
            {t(messages.usOfferTableHeaderMaturity)}
          </S.Text>
          <S.Text variant="subtitle1">{maturityDisplay}</S.Text>
        </MobileStyles.MobileItem>
      )}
      <MobileStyles.MobileItem>
        <S.Text variant="subtitle1" $color={'black60'}>
          {t(messages.usOfferTableHeaderAnnualizedEarnings)}
        </S.Text>
        <S.Text variant="subtitle1">{earnings}</S.Text>
      </MobileStyles.MobileItem>
      <MobileStyles.MobileItem>
        <Link
          onClick={() => loadingProductId !== id && openProductTerms(id)}
          style={{
            marginTop: '8px',
            marginBottom: '8px',
            color: loadingProductId === id && 'grey',
            cursor: loadingProductId === id && 'wait',
          }}
        >
          {t(messages.usOfferTableProductTerms)}
        </Link>
      </MobileStyles.MobileItem>
      <FinancialInstitutions
        financialInstitutions={getInstitutionChipLabels(financialInstitutions)}
      />
      <MobileStyles.MobileItem>
        <Button fullWidth onClick={() => onInvest(id)}>
          {t(messages.usOfferTableSaveButton)}
        </Button>
      </MobileStyles.MobileItem>
    </MobileStyles.MobileItemContainer>
  );
};
